__turbopack_context__.v({
  "aboutBox": "page-module__Ar7_Cq__aboutBox",
  "aboutImage": "page-module__Ar7_Cq__aboutImage",
  "actions": "page-module__Ar7_Cq__actions",
  "actionsRight": "page-module__Ar7_Cq__actionsRight",
  "callout": "page-module__Ar7_Cq__callout",
  "center": "page-module__Ar7_Cq__center",
  "dot": "page-module__Ar7_Cq__dot",
  "errorMessage": "page-module__Ar7_Cq__errorMessage",
  "eyebrow": "page-module__Ar7_Cq__eyebrow",
  "footer": "page-module__Ar7_Cq__footer",
  "footerInner": "page-module__Ar7_Cq__footerInner",
  "form": "page-module__Ar7_Cq__form",
  "formGrid": "page-module__Ar7_Cq__formGrid",
  "header": "page-module__Ar7_Cq__header",
  "hero": "page-module__Ar7_Cq__hero",
  "heroCopy": "page-module__Ar7_Cq__heroCopy",
  "introPanel": "page-module__Ar7_Cq__introPanel",
  "kicker": "page-module__Ar7_Cq__kicker",
  "lead": "page-module__Ar7_Cq__lead",
  "loader": "page-module__Ar7_Cq__loader",
  "note": "page-module__Ar7_Cq__note",
  "option": "page-module__Ar7_Cq__option",
  "optionIcon": "page-module__Ar7_Cq__optionIcon",
  "options": "page-module__Ar7_Cq__options",
  "page": "page-module__Ar7_Cq__page",
  "primaryButton": "page-module__Ar7_Cq__primaryButton",
  "progress": "page-module__Ar7_Cq__progress",
  "progressWrap": "page-module__Ar7_Cq__progressWrap",
  "proof": "page-module__Ar7_Cq__proof",
  "question": "page-module__Ar7_Cq__question",
  "quizCard": "page-module__Ar7_Cq__quizCard",
  "quizShell": "page-module__Ar7_Cq__quizShell",
  "resultBadge": "page-module__Ar7_Cq__resultBadge",
  "roleButton": "page-module__Ar7_Cq__roleButton",
  "roleLine": "page-module__Ar7_Cq__roleLine",
  "roleList": "page-module__Ar7_Cq__roleList",
  "rolePanel": "page-module__Ar7_Cq__rolePanel",
  "scoreLine": "page-module__Ar7_Cq__scoreLine",
  "secondaryButton": "page-module__Ar7_Cq__secondaryButton",
  "selected": "page-module__Ar7_Cq__selected",
  "spin": "page-module__Ar7_Cq__spin",
  "stars": "page-module__Ar7_Cq__stars",
  "stepsGrid": "page-module__Ar7_Cq__stepsGrid",
  "stepsSection": "page-module__Ar7_Cq__stepsSection",
  "summary": "page-module__Ar7_Cq__summary",
  "testimonial": "page-module__Ar7_Cq__testimonial",
  "testimonialGrid": "page-module__Ar7_Cq__testimonialGrid",
  "whatsappButton": "page-module__Ar7_Cq__whatsappButton",
});
